$(document).on('click', '.menu-group a', function (e) {
    e.preventDefault();
    let ele = $(this);
    let elementVal = $(this).html();
    let mainHeader = $(this).parents('.nav-item.dropdown').find('a.nav-link').text(); 

    let subHeader = $(this).parents('.menu-list-item').siblings('.nav-name-sperator').text();
    let nextPage = $(this).attr('href');

    let url = $('#customerNoUrl').val();
    let customerId="";

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            if (mainHeader == undefined) {
                if( $(this).hasClass('shop-all') ) {
                    subHeader = $(this).prev('.nav-name-sperator').text();
                    mainHeader = $(this).closest('.nav-item.dropdown.show').find('.nav-link.dropdown-toggle').text();
                } else {
                    mainHeader = 'root';
                }
            }
        
            window.dataLayer.push({
                event: "Menu_Navigation",
                click_text: elementVal,
                section_clicked: "Menu_Navigation",
                user_id:customerId,
                link_header: mainHeader,
                link_sub_header: subHeader,
                nextPage: nextPage,
                currentPage: window.location.href,
            });
            if( $('.header').hasClass('nav-open')) {
                if(!ele.hasClass('dropdown-toggle') ) {
                    window.location.href = nextPage;
                }
            } else {
                window.location.href = nextPage;
            }
    }});
});

$('.site-search .search-field').on('keypress', function(e) {
    if(e.which === 13) {       
        e.preventDefault();
        var searchValue = $(this).val();
        let url = $('#customerNoUrl').val();
        console.log('url :- '+ url);
        let customerId="";
        let nextPage = $('.site-search form').attr('action');
        nextPage = nextPage + '?q=' + searchValue;
        
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success(dataFromAjax) {
                if(dataFromAjax.customerId){
                    customerId = dataFromAjax.customerId;
                }
                // console.log('customerId :- '+ customerId);
                // console.log('nextPage :- '+ nextPage);
                navigationDataLayers('search_box_clicked',customerId,nextPage);
                window.location.href = nextPage;
            }
        });
    }
});

function navigationDataLayers(click_text,customerId,nextPage) {

    window.dataLayer.push({
        event: "Top_Navigation",
        click_text: click_text,
        section_clicked: "Top_Navigation",
        user_id:customerId,
        nextPage:nextPage, 
        currentPage: window.location.href 
    });
}

$(document).on('click', '#search-results a.link', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).attr('href');
    let searchVal = 'search_'+$(this).text().trim();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers(searchVal,customerId,nextPage);
            window.location.href = nextPage;
        }
    });
});

$(document).on('click', '.logo-home', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).attr('href');
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('logo_clicked',customerId,nextPage);
            window.location.href = nextPage;
        }
    });
});

$(document).on('click', '.dropdown-menu.dropdown-country-selectors .dropdown-item', function (e) {
    e.preventDefault();
    var countryName = $(this).text().trim();
    var country = countryName.split('(')[0];
    let url = $('#customerNoUrl').val();
    let customerId="";
    let urlss = $(this).data('urlss');
    let nextPage = $(this).attr('href');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            } 
            navigationDataLayers('ship_' + country,customerId,urlss);
            window.location.href = urlss;
        }
    });
});

$(document).on('click', '.whatsapp-chat', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).attr('href');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('whatsApp_chat',customerId,nextPage);
            window.location.href = nextPage;
        }
    });
});


$(document).on('click', '.header-desktop-wishlist-icon', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).attr('href');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('wishlist_clicked',customerId,nextPage);
            window.location.href = nextPage;
        }
    });
});


$(document).on('click', '.icon-profile-black-header-icn', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).data('url');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('userLogin_clicked',customerId,nextPage);
            if ($(".js-logged").hasClass("user-logged-in")) {
                window.location.href = nextPage;
            }
        }
    });
    
});

$(document).on('click', '.profile-msg', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).data('url');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('userLogin_clicked',customerId,nextPage);
            if ($(".js-logged").hasClass("user-logged-in")) {
                window.location.href = nextPage;
            }
        }
    });
    
});
$(document).on('click', '.profile-circle', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).data('url');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('userLogin_clicked',customerId,nextPage);
            if ($(".js-logged").hasClass("user-logged-in")) {
                window.location.href = nextPage;
            }
        }
    });
    
});


$(document).on('click', '.minicart-link', function (e) {
    e.preventDefault();
    let url = $('#customerNoUrl').val();
    let customerId="";
    let nextPage = $(this).attr('href');

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            navigationDataLayers('cart_clicked',customerId,nextPage);
            window.location.href = nextPage;
        }
    });
});

$(document).on('click', "div[class$='layouts-flexibleCarousel'] .ITC-container:not(.banner-component)", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let sectionClicked = currentElement.find('img').attr('title');
    let nextPageLink = currentElement.find('a').attr('href');
    let url = $('#customerNoUrl').val();
	let titleText='';
    var nearestTitle = currentElement.closest('.experience-component').find('.carousel-title');        
    if (nearestTitle) {
        titleText = nearestTitle.text();
    }
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Section_Info",
                click_text: sectionClicked, // pass click information dynamically
                section_clicked: titleText, // pass section info dynamically
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            window.location.href = nextPageLink;
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', ".experience-component.experience-custom_commerce_layouts-flexibleCarousel .flexible-slider .slide-item", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let sectionClicked = currentElement.find('img').attr('title');
    let nextPageLink = currentElement.find('a').attr('href');
    let url = $('#customerNoUrl').val();
    let indexItem =  $(this).data('slick-index'); 
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Section_Info",
                click_text: sectionClicked, // pass click information dynamically
                section_clicked: indexItem, // pass section info dynamically
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            window.location.href = nextPageLink;
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', "div[class$='layouts-mobileGrid3r2c'] .region .ITC-container", function (e) {
    e.preventDefault();
    let currentElement = $(this);
    let parentComponent = currentElement.closest('.grid-row');
    let allContainers = parentComponent.find('.ITC-container');
    let indexItem = allContainers.index(currentElement) + 1; 
    let sectionClicked = currentElement.find('img').attr('title');
    let nextPageLink = currentElement.find('a').attr('href');
    let url = $('#customerNoUrl').val();
    let customerId="";

    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Section_Info",
                click_text: sectionClicked, 
                section_clicked: indexItem, 
                user_id:customerId,
                currentPage: window.location.href, 
                nextPage: nextPageLink // Need to pass next page url
            });
            window.location.href = nextPageLink;
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });

});
$(document).on('click', "div[class$='layouts-flexibleCarousel'] .full-width-container .ITC-container", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let sectionClicked = currentElement.find('img').attr('title');
    let nextPageLink = currentElement.find('a').attr('href');
    let url = $('#customerNoUrl').val();
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Banner_Click",
                click_text: sectionClicked, // pass click information dynamically
                banner_position: '1',  
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            window.location.href = nextPageLink;
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', "div[class$='layouts-flexibleCarousel'] .experience-component.experience-custom_commerce_assets-dtmImageTile .ITC-container", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let sectionClicked = currentElement.find('img').attr('title');
    let nextPageLink = currentElement.find('a').attr('href');
    let url = $('#customerNoUrl').val();
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Banner_Click",
                click_text: sectionClicked, // pass click information dynamically
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            window.location.href = nextPageLink;
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', "div[class$='experience-custom_einstein-einsteinCarousel'] .einstein-carousel.products-in-all-categories .product-tile a", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let dataSlickIndex = currentElement.parent().attr('data-slick-index');
    let textClicked = currentElement.find('img').attr('title');
    let sectionClicked = currentElement.closest('.einstein-carousel.products-in-all-categories').data().sectionType;
    let nextPageLink = currentElement.attr('href');
    let url = $('#customerNoUrl').val();
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Section_Info",
                click_text: textClicked,
                section_clicked: sectionClicked, // pass click information dynamically
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            if (!$(e.target).closest('a').hasClass('js-btn-wishlist')){
                window.location.href = nextPageLink; 
             }
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', ".experience-component.experience-custom_commerce_assets-dtmImageTile .ITC-container", function (e) {
    if (!$(this).closest('.experience-custom_commerce_layouts-flexibleCarousel').length) {
        if (!$(this).closest('.experience-commerce_layouts-mobileGrid3r2c').length) {
            e.preventDefault();
            let currentElement= $(this);
            let sectionClicked = currentElement.find('img').attr('title');
            let nextPageLink = currentElement.find('a').attr('href');
            let titleText='';
            var nearestTitle = null;
            currentElement.closest('.experience-component').prevAll('.experience-component').each(function() {
                var $this = $(this);
                var $title = $this.find('.carousel-title').first();
                if ($title.length > 0) {
                    nearestTitle = $title;
                    return false; // Exit loop once the nearest title is found
                }
            });
            if (!nearestTitle) {
                currentElement.closest('.experience-component').prevAll().each(function() {
                    var $this = $(this);
                    var $title = $this.find('.carousel-title').first();
                    if ($title.length > 0) {
                        nearestTitle = $title;
                        return false; // Exit loop once the nearest title is found
                    }
                });
                
            }
            if (nearestTitle) {
                titleText = nearestTitle.text();
            }
            
            let index = $('.experience-component.experience-custom_commerce_assets-dtmImageTile .ITC-container')
            .filter(function() {
            // Exclude elements if any ancestor has the class 'region'
            return $(this).closest('.region').length === 0;
            })
            .length;
                    
            let url = $('#customerNoUrl').val();
            let customerId="";
            $.ajax({
                url,
                type: 'get',
                success(data) {
                    if(data.customerId){
                        customerId = data.customerId;
                    }
                    dataLayer.push({
                        event: "Banner_Click",
                        click_text: sectionClicked, 
                        section_clicked: "Hero_Banner",
                        link_header: titleText,
                        banner_position: index + 1,   
                        user_id:customerId,
                        currentPage: window.location.href, // Need to pass current page url
                        nextPage: nextPageLink // Need to pass next page url
                    });
                    window.location.href = nextPageLink;
                },
                error() {
                    console.error('Error fetching content:', error);
                },
            });
        }
    }
});

$('form[name="newsletter"]').on('submit', function(event) {
    let url = $('#customerNoUrl').val();
    let customerId="";
    
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Newsletter_Signup",
                click_text: "email_subscribed", 
                userID: customerId,
                nextPage:"#", //Need to pass next page url
                currentPage: window.location.href, //Need to pass current page url 
            });
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});

$(document).on('click', ".experience-component.experience-custom_einstein-einsteinCarousel .einstein-carousel .carousel-inner .viewed-recently .slide-item a", function (e) {
    e.preventDefault();
    let currentElement= $(this);
    let textClicked = currentElement.find('img').attr('title');
    let sectionClicked = 'Recently Viewed';
    let nextPageLink = currentElement.attr('href');
    let url = $('#customerNoUrl').val();
    let customerId="";
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.customerId){
                customerId = data.customerId;
            }
            dataLayer.push({
                event: "Section_Info",
                click_text: textClicked,
                section_clicked: sectionClicked, // pass click information dynamically
                user_id:customerId,
                currentPage: window.location.href, // Need to pass current page url
                nextPage: nextPageLink // Need to pass next page url
            });
            if (!$(e.target).closest('a').hasClass('js-btn-wishlist')){
                window.location.href = nextPageLink; 
             }
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
});
